import React from "react";

const items = [
  "FSSAI Licensed",
  "USDA Organic",
  "ISO 3632 · Saffron Cat I",
  "Spices Board India",
  "Fair Trade Sourced",
  "Lab Tested · DGFT Export Cleared",
];

export default function Marquee() {
  const loop = [...items, ...items];
  return (
    <div data-testid="trust-marquee" className="bg-[#EAE6DB] border-y border-[#D5D1C5] overflow-hidden">
      <div className="marquee-track flex whitespace-nowrap py-5">
        {loop.map((t, i) => (
          <span
            key={i}
            className="font-serif-display italic text-2xl md:text-3xl text-[#4A5D23] px-10 flex items-center"
          >
            {t}
            <span className="ml-10 text-[#C84B31]">✦</span>
          </span>
        ))}
      </div>
    </div>
  );
}
